<template>
  <el-dialog
    v-model="visible"
    title="공지 상세"
    width="600px"
    @close="$emit('close')"
  >
    <div v-if="!editMode">
      <h3>{{ notice.title }}</h3>
      <!-- eslint-disable-next-line vue/no-v-html -- DOMPurify로 새니타이징된 값만 바인딩됨 (utils/sanitizeHtml.js) -->
      <div v-html="sanitizeHtml(notice.content)" />
      <p><strong>기간:</strong> {{ notice.start_date }} ~ {{ notice.end_date }}</p>

      <div class="mt-4">
        <el-button type="primary" @click="editMode = true">수정</el-button>
        <el-button type="danger" @click="deleteNotice">삭제</el-button>
        <el-button @click="$emit('close')">닫기</el-button>
      </div>
    </div>

    <div v-else>
      <el-input v-model="form.title" placeholder="제목" />
      <QuillEditor v-model:content="form.content" contentType="html" />
      <el-date-picker
        v-model="form.dates"
        type="datetimerange"
        start-placeholder="시작"
        end-placeholder="종료"
      />
      <div class="mt-4">
        <el-button type="success" @click="updateNotice">저장</el-button>
        <el-button @click="editMode = false">취소</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import axios from '@/api/axios'
import { QuillEditor } from '@vueup/vue-quill'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

const props = defineProps({ notice: { type: Object, default: () => ({}) } })
const emit = defineEmits(['close', 'updated'])

const visible = ref(true)
const editMode = ref(false)

const form = ref({ title: '', content: '', dates: [] })

watch(() => props.notice, (n) => {
  if (n) {
    form.value.title = n.title
    form.value.content = n.content
    form.value.dates = [n.start_date, n.end_date]
  }
}, { immediate: true })

const updateNotice = async () => {
  try {
    await axios.put(`/notices/${props.notice.id}/`, {
      title: form.value.title,
      content: form.value.content,
      start_date: form.value.dates[0],
      end_date: form.value.dates[1]
    })
    ElMessage.success('수정되었습니다.')
    emit('updated')
    emit('close')
  } catch {
    ElMessage.error('수정 실패')
  }
}

const deleteNotice = async () => {
  try {
    await ElMessageBox.confirm('이 공지를 삭제할까요?', '확인', { type: 'warning' })
    await axios.delete(`/notices/${props.notice.id}/`)
    ElMessage.success('삭제되었습니다.')
    emit('updated')
    emit('close')
  } catch  (err){
    console.warn('삭제 취소됨 또는 실패:', err)


  }
}
</script>
<!-- .mt-4 전역 중복 정의 제거 — common.css 의 공식 유틸 사용 (2026-06-11) -->